module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesCool@2x.d8774ed.jpg";